import type {Feat} from '../../../generated/types';
import {FeatCategories} from '../../../components/enums';
import {composeDescription, stripMarkup} from '../../../lib/seo/text';
import type {OgCardData} from '../../../lib/seo/site';

/** «Черта Происхождения», «Универсальная черта»… */
export function featCategoryText(feat: Pick<Feat, 'category'>): string {
	return (feat.category && FeatCategories[feat.category]) || 'Черта';
}

/**
 * В prerequisite лежит весь подзаголовок карточки: «Универсальная черта (Требования: 4-й уровень или выше)».
 * Категорию берём из category, отсюда — только требования в скобках.
 */
function requirementsText(feat: Pick<Feat, 'prerequisite'>): string {
	const match = stripMarkup(feat.prerequisite).match(/\(\s*требования:\s*([^)]*)\)/i);
	return match ? match[1].replace(/[.\s]+$/, '').trim() : '';
}

/** «Универсальная черта Атлет. Требования: 4-й уровень или выше, Сила или Ловкость 13 или выше. …» */
export function featDescription(feat: Feat): string {
	const parts = [`${featCategoryText(feat)} ${feat.title}.`];
	const requirements = requirementsText(feat);
	if (requirements) parts.push(`Требования: ${requirements}.`);
	const text = [feat.description, ...(feat.features || []).map((f) => f.description)].filter(Boolean).join(' ');
	return composeDescription(parts.join(' '), text);
}

export function featOgCard(feat: Feat): OgCardData {
	const requirements = requirementsText(feat);
	return {
		label: 'Черта',
		title: feat.title,
		originalTitle: feat.originalTitle,
		subtitle: [featCategoryText(feat), requirements && `требования: ${requirements}`].filter(Boolean).join(' · '),
	};
}
